import React, { useEffect } from 'react';
import { StepProps } from '../../types/onboarding';
const STATES_DATA = [{
  id: 'CA',
  name: 'California',
  path: 'M10,5 L15,5 L20,15 L25,30 L20,35 L10,35 L5,20 Z'
}, {
  id: 'TX',
  name: 'Texas',
  path: 'M15,5 L25,5 L30,15 L35,25 L25,35 L15,30 L5,20 L10,10 Z'
}, {
  id: 'FL',
  name: 'Florida',
  path: 'M5,5 L25,5 L30,15 L35,35 L25,30 L15,20 L10,10 Z'
}, {
  id: 'NY',
  name: 'New York',
  path: 'M10,5 L25,5 L35,15 L30,25 L20,20 L10,25 L5,15 Z'
}, {
  id: 'WA',
  name: 'Washington',
  path: 'M5,5 L35,5 L35,25 L5,25 L5,15 L10,10 Z'
}, {
  id: 'OR',
  name: 'Oregon',
  path: 'M5,5 L35,5 L35,25 L5,25 Z'
}, {
  id: 'NV',
  name: 'Nevada',
  path: 'M10,5 L30,5 L30,35 L10,15 Z'
}, {
  id: 'AZ',
  name: 'Arizona',
  path: 'M5,5 L25,5 L25,15 L35,15 L35,35 L5,35 Z'
}, {
  id: 'CO',
  name: 'Colorado',
  path: 'M5,5 L35,5 L35,25 L5,25 Z'
}, {
  id: 'IL',
  name: 'Illinois',
  path: 'M15,5 L25,5 L25,35 L15,35 L10,20 Z'
}];
export function StatesLicensed({
  data,
  updateData,
  setCanAdvance
}: StepProps) {
  useEffect(() => {
    setCanAdvance(true);
  }, [setCanAdvance]);
  const toggleState = (id: string) => {
    const current = data.statesLicensed;
    const newValues = current.includes(id) ? current.filter(v => v !== id) : [...current, id];
    updateData({
      statesLicensed: newValues
    });
  };
  const selectedCount = data.statesLicensed.length;
  return <div className="space-y-6" data-id="element-266">
      <div className="flex items-center justify-between" data-id="element-267">
        <h3 className="text-sm font-medium text-gray-700" data-id="element-268">
          Select Licensed States
        </h3>
        <div className="bg-blue-50 text-[#2563EB] px-3 py-1 rounded-full text-xs font-semibold" data-id="element-269">
          {selectedCount} of {STATES_DATA.length} selected
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-4" data-id="element-270">
        {STATES_DATA.map(state => {
        const isSelected = data.statesLicensed.includes(state.id);
        return <button key={state.id} onClick={() => toggleState(state.id)} className={`flex flex-col items-center justify-center p-4 rounded-xl border transition-all ${isSelected ? 'border-[#2563EB] bg-blue-50 shadow-md ring-1 ring-[#2563EB]/20' : 'border-gray-200 bg-white shadow-sm hover:border-gray-300 hover:bg-gray-50'}`} data-id="element-271">
              <svg viewBox="0 0 40 40" className={`w-12 h-12 mb-3 transition-colors ${isSelected ? 'fill-[#2563EB]' : 'fill-gray-300'}`} data-id="element-272">
                <path d={state.path} data-id="element-273" />
              </svg>
              <span className={`text-lg font-bold ${isSelected ? 'text-[#2563EB]' : 'text-gray-900'}`} data-id="element-274">
                {state.id}
              </span>
              <span className={`text-xs mt-1 ${isSelected ? 'text-blue-700' : 'text-gray-500'}`} data-id="element-275">
                {state.name}
              </span>
            </button>;
      })}
      </div>
    </div>;
}